module.exports = __webpack_public_path__ + "img/img20.9a0994cb.png";